import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InvitationRevocationFailedAction = {
	type: 'INVITATION_REVOCATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InvitationRevocationFailedAction => ({
	type: 'INVITATION_REVOCATION_FAILED',
	payload,
});
